import script from "./Leaderboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Leaderboard.vue?vue&type=script&setup=true&lang=js"

import "./Leaderboard.vue?vue&type=style&index=0&id=a0f15a4c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/set-repository-web-glasses/glasses-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0f15a4c"]])

export default __exports__